import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";

const CAT_LABEL = { research: "Research", policy: "Policy", industry: "Industry" };

export default function ArticleDetail() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [missing, setMissing] = useState(false);

  /* eslint-disable */
  useEffect(() => {
    let cancelled = false;
    setA(null); setMissing(false);
    (async () => {
      try {
        const r = await api.get(`/articles/${slug}`);
        if (!cancelled) setA(r.data);
      } catch {
        if (!cancelled) setMissing(true);
      }
    })();
    return () => { cancelled = true; };
  }, [slug]);
  /* eslint-enable */

  if (missing) {
    return (
      <div className="max-w-[900px] mx-auto px-6 lg:px-12 py-24" data-testid="article-not-found">
        <p className="overline">404</p>
        <h1 className="mt-6 font-display text-4xl">Article not found.</h1>
        <Link to="/intelligence" className="mt-8 inline-flex items-center gap-2 eai-link reveal-underline">
          <ArrowLeft size={16} /> Back to Intelligence
        </Link>
      </div>
    );
  }
  if (!a) {
    return <div className="max-w-[900px] mx-auto px-6 lg:px-12 py-24 font-mono-eai text-sm uppercase tracking-[0.18em] text-[var(--eai-ink-2)]">Loading…</div>;
  }

  return (
    <article data-testid="article-detail-page">
      <header className="border-b border-[var(--eai-border)]">
        <div className="max-w-[900px] mx-auto px-6 lg:px-12 py-16 lg:py-24">
          <Link to="/intelligence" className="inline-flex items-center gap-2 text-xs font-mono-eai uppercase tracking-[0.18em] text-[var(--eai-ink-2)] hover:text-[var(--eai-ink)]" data-testid="back-to-intelligence-link">
            <ArrowLeft size={14} /> Back to Intelligence
          </Link>
          <p className="overline mt-8">{CAT_LABEL[a.category]}</p>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.02]">
            {a.title}
          </h1>
          <p className="mt-6 text-lg text-[var(--eai-ink-2)] leading-relaxed">{a.summary}</p>
          <div className="mt-8 flex items-center gap-6 text-xs font-mono-eai uppercase tracking-[0.18em] text-[var(--eai-ink-2)]">
            <span>{a.author}</span>
            <span>·</span>
            <span>{a.read_minutes} min read</span>
            <span>·</span>
            <span>{new Date(a.published_at).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })}</span>
          </div>
        </div>
      </header>

      <div className="max-w-[760px] mx-auto px-6 lg:px-12 py-16 lg:py-24">
        {a.body.split("\n\n").map((para, i) => (
          <p key={`${a.slug}-p-${i}`} className="font-display text-xl lg:text-[22px] leading-[1.65] text-[var(--eai-ink)] mb-8">
            {para}
          </p>
        ))}
        {a.tags?.length > 0 && (
          <div className="mt-12 pt-8 border-t border-[var(--eai-border)] flex flex-wrap gap-2">
            {a.tags.map((t) => (
              <span key={t} className="px-3 py-1 text-xs font-mono-eai uppercase tracking-[0.16em] border border-[var(--eai-border)] text-[var(--eai-ink-2)]">
                #{t}
              </span>
            ))}
          </div>
        )}
      </div>
    </article>
  );
}
